<template>
  <v-card
    class="ma-0 mb-4 mt-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 py-1"
      dense
      height="30"
    >
      <v-chip-group>
        <v-chip
          label
          outlined
          color="red"
        >
          {{ $t('firstCost') }} : {{ (costs ? $numberFormat(costs.first) + ' ' + $store.state.currency.name : '') }}
        </v-chip>
        <v-chip
          label
          outlined
          color="pink"
        >
          {{ $t('minCost') }} : {{ (costs ? $numberFormat(costs.min) + ' ' + $store.state.currency.name : '') }}
        </v-chip>
        <v-chip
          label
          outlined
          color="green"
        >
          {{ $t('averageCost') }} : {{ (costs ? $numberFormat(costs.average) + ' ' + $store.state.currency.name : '') }}
        </v-chip>
        <v-chip
          label
          outlined
          color="purple"
        >
          {{ $t('maxCost') }} : {{ (costs ? $numberFormat(costs.max) + ' ' + $store.state.currency.name : '') }}
        </v-chip>
        <v-chip
          label
          outlined
          color="deep-purple"
        >
          {{ $t('lastCost') }} : {{ (costs ? $numberFormat(costs.last) + ' ' + $store.state.currency.name : '') }}
        </v-chip>
      </v-chip-group>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f2']"
            v-bind="attrs"
            icon
            small
            class="mx-1"
            @shortkey="addRow()"
            v-on="on"
            @click="addRow()"
          >
            <v-icon
              color="teal"
              style="font-size: 22px"
            >
              mdi-plus-box-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('newRow') }} (f2)</span>
      </v-tooltip>
    </v-app-bar>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-row class="mx-0 my-2" />
      <v-col
        cols="12"
        class="px-2 py-0 "
      >
        <v-data-table
          v-if="headers"
        :height="tableHeight"
        fixed-header
          v-model="selected"
          :headers="headers"
          :items="items"
          :options.sync="tableOptions"
          :server-items-length="totalItems"
          :loading="loading"
          multi-sort
          dense
          :show-select="showSelect"
          hide-default-footer
          item-key="id"
        >
          <template v-slot:item.actions="{ item }">
            <v-menu
              offset-y
            >
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  color="primary"
                  v-bind="attrs"
                  icon
                  v-on="on"
                >
                  <v-icon
                    medium
                  >
                    mdi-dots-vertical
                  </v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  link
                  @click="openDeleteDialog(item)"
                >
                  <v-list-item-icon>
                    <v-icon color="pink">
                      mdi-trash-can-outline
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="$t('remove')" />
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-slot:item.row="{ item }">
            {{ parseInt(items.indexOf(item))+ parseInt(from) }}
          </template>
          <template v-slot:item.product="{ item }">
            <autocomplete
              :ref="'refProduct' + parseInt(items.indexOf(item))"
              v-model="item.product"
              :value="item.product"
              class="mb-3"
              :rules="[v => !!v || $t('is-required')]"
              type="product"
              :disabled="!entrepot"
              :data="JSON.stringify({entrepot:(entrepot ? entrepot.id : null)})"
              :new-btn="true"
              @input="checkProduct(item.product, parseInt(items.indexOf(item)))"
            />
          </template>
          <template v-slot:item.type="{ item }">
            <v-select
              v-model="item.type"
              :items="typeItems"
              height="30"
              dense
              outlined
              class="mb-3"
              item-value="value"
              item-text="text"
              @change="changetype(item)"
            />
          </template>
          <template v-slot:item.name="{ item }">
            <v-text-field
              v-model="item.name"
              height="20"
              dense
              solo
              flat
              :rules="[v => !!v || $t('is-required')]"
              class="mb-3 dense"
              clearable
              :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
              :placeholder="$t('name')"
            />
          </template>
          <template v-slot:item.category="{ item }">
            <autocomplete
              v-model="item.category"
              :label="$t('account-category')"
              type="accountCategory"
              class="mb-3"
              :set-init="false"
              :value="item.category"
            />
          </template>
          <template v-slot:item.currency="{ item }">
            <autocomplete
              ref="refCategory"
              v-model="item.currency"
              :label="$t('account-category')"
              type="currency"
              class="mb-3"
              :set-init="true"
              :value="item.currency"
            />
          </template>
          <template v-slot:item.min="{ item }">
            <v-text-field
              v-model="item.min"
              height="20"
              dense
              solo
              flat
              class="mb-3 dense"
              :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
              :placeholder="$t('count')"
              type="number"
            />
          </template>
          <template v-slot:item.branch="{ item }">
            <aicomplete
              v-model="item.branch"
              title="branch"
              type="branch"
              class="mb-3"
              :set-init="false"
              :val="item.branch"
              :new-btn="true"
            />
          </template>
          <template v-slot:item.max="{ item }">
            <v-text-field
              v-model="item.max"
              height="20"
              dense
              solo
              flat
              class="mb-3 dense"
              :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
              :placeholder="$t('count')"
              type="number"
            />
          </template>
          <template v-slot:item.woocommerce="{ item }">
            <div>
              <v-checkbox
                v-model="item.woocommerce"
                class="mx-4 ma-0 mb-3"
                style="height: 20px"
                value="active"
              />
            </div>
          </template>
          <template v-slot:item.percent="{ item }">
            <v-text-field
              v-model="item.percent"
              height="20"
              dense
              solo
              flat
              class="mb-3 dense"
              clearable
              :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
              :placeholder="$t('percent')"
              type="number"
              @keyup="calPrice(item)"
            />
          </template>
          <template v-slot:item.price="{ item }">
            <money
              v-model="item.price"
              :dense="true"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
              class="mb-3 dense"
              @input="onkeyPrice(item)"
            />
          </template>
        </v-data-table>
      </v-col>
      <v-divider class="mx-2" />
      <v-card-actions class="pt-0" />
      <v-row />
    </v-form>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  import General from '../../../../Mixins/general'
  export default {
    name: 'SellList',
    components: {
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      autocomplete: () => import('../../components/general/patial/autocomplete'),
    },
    mixins: [General],
    props: ['input', 'formType', 'value', 'costs', 'method'],
    data: () => ({
      selected: [],
      printDialog: false,
      deletDialog: false,
      showSelect: false,
      render: false,
      filter: false,
      valid: true,
      detail: null,
      recipientEntrepot: null,
      relations: null,
      productStatus: null,
      productStatusItems: null,
      date: null,
      entrepot: null,
      model: null,
      from: 1,
      taskDialog: null,
      id: null,
      status: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 1000,
      isLoading: false,
      snakbar: false,
      typeForm: null,
      type: 'receipt',
      taskId: null,
      snakbarText: null,
      loading: true,
      tableOptions: {
        itemsPerPage: 1000,
      },
      headers: null,
      search: null,
    }),
    watch: {
      value () {
      },
      items: {
        handler: function (val, oldVal) {
          this.$emit('input', this.items)
        },
        deep: true,
      },
      refId (val, oldVal) {
        // this.items = []
        // this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      tableOptions: {
        handler () {
          var app = this
          app.sortBy = []
          app.tableOptions.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      relations () {
        var app = this
        if (app.relations && app.relations.article) {
          app.items = []
          app.items = app.relations.article
        } else {
          app.addRow()
        }
      },
    },
    beforeMount () {
      this.type = this.$route.name
      if (this.$route.params.id != null) {
        this.render = false
        this.id = this.$route.params.id
      } else {
        this.render = true
        this.addRow()
      }
    },
    mounted () {
      if (this.value) {
        this.items = this.value
      }
      this.headers = [
        {
          text: '#',
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 40,
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 40,
        },
        {
          text: this.$t('type'),
          sortable: false,
          value: 'type',
          width: 150,
        },
        {
          text: this.$t('name'),
          sortable: false,
          value: 'name',
          width: 150,
        },
        {
          text: this.$t('account-category'),
          sortable: false,
          value: 'category',
          width: 150,
        },
        {
          text: this.$t('branch'),
          sortable: false,
          value: 'branch',
          width: 150,
        },
        {
          text: this.$t('currency'),
          sortable: false,
          value: 'currency',
          width: 150,
        },
        {
          text: this.$t('min') + '(' + this.$t('count') + ')',
          sortable: false,
          value: 'min',
          width: 100,
        },
        {
          text: this.$t('max') + '(' + this.$t('count') + ')',
          sortable: false,
          value: 'max',
          width: 100,
        },
        {
          text: this.$t('percent'),
          sortable: false,
          value: 'percent',
          width: 150,
        },
        {
          text: this.$t('price'),
          sortable: false,
          value: 'price',
          width: 150,
        },
      ]
      this.typeItems = [
        {
          value: 'price',
          text: this.$t('sellPrice'),
        },
        {
          value: 'discount',
          text: this.$t('discount'),
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      this.loading = false
    },
    methods: {
      changetype (item) {
        item.percent = null
        item.price = null
      },
      onkeyPrice (item) {
        item.percent = null
      },
      calPrice (item) {
        if (item.percent && item.type === 'price') {
          var profit = parseFloat(this.costs[this.method]) * (item.percent / 100)
          item.price = parseFloat(profit) + parseFloat(this.costs[this.method])
        }
      },
      addRow () {
        this.items.push({
          product: null,
          min: null,
          max: null,
          price: null,
          type: 'price',
          name: null,
          percent: null,
          branch: null,
          category: null,
          currency: null,
          woocommerce: null,
        })
      },
      remove () {
        var index = this.items.indexOf(this.deleteItem)
        this.items.splice(index, 1)
        this.deletDialog = false
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
    },
  }
</script>

<style scoped>

</style>
